import { BehaviorSubject } from 'rxjs';

export const miniCartOffset$ = new BehaviorSubject({});

export const miniCartOffset = miniCartOffset$.asObservable();